import React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

// Mask para CPF e CNPJ, caso o value.length seja menor que 11, CPF mask, se não, CNPJ mask
const CnpjCpfInput = React.forwardRef<HTMLInputElement, CustomProps>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={props.name === 'document_number' ? 'AA.AAA.AAA/AAAA-00' : '000.000.000-00'}
      definitions={{
        A: /[A-Za-z0-9]/,
      }}
      inputRef={ref}
      prepare={value => value.toUpperCase()}
      onAccept={(value: string) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export default CnpjCpfInput;
